export enum AmcContractStatus {
  DRAFT = "DRAFT",
  READY_FOR_ACTIVATION = "READY_FOR_ACTIVATION",
  ACTIVE = "ACTIVE",
  /** Completed via a single manual action (POST /amc/:id/complete) — no end-date gating, callable any time from ACTIVE. */
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum AmcSourceType {
  QUOTATION = "QUOTATION",
  MANUAL = "MANUAL",
  RENEWAL = "RENEWAL",
  MIGRATION = "MIGRATION",
}

export enum AmcBillingType {
  FULL_UPFRONT = "FULL_UPFRONT",
}

export const AmcSourceTypeLabelMap: Record<AmcSourceType, string> = {
  [AmcSourceType.QUOTATION]: "Quotation",
  [AmcSourceType.MANUAL]: "Manual Entry",
  [AmcSourceType.RENEWAL]: "Renewal",
  [AmcSourceType.MIGRATION]: "Migrated Contract",
};

export const AmcBillingTypeLabelMap: Record<AmcBillingType, string> = {
  [AmcBillingType.FULL_UPFRONT]: "Full upfront",
};

export const amcStatusMap = {
  [AmcContractStatus.DRAFT]: {
    label: "Draft",
    color: "secondary",
  },
  [AmcContractStatus.ACTIVE]: {
    label: "Active",
    color: "warning",
  },

  [AmcContractStatus.READY_FOR_ACTIVATION]: {
    label: "Ready For Activation",
    color: "success",
  },

  [AmcContractStatus.COMPLETED]: {
    label: "Completed",
    color: "primary",
  },
  [AmcContractStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
  },
} as const;
